import { Project } from '../tokens/project-token';

// eslint-disable-next-line @typescript-eslint/naming-convention
declare const JS_PATH: string;
// eslint-disable-next-line @typescript-eslint/naming-convention
declare const CSS_PATH: string;

export const projectShared: Project = {
  jsPath: JS_PATH,
  cssPath: CSS_PATH
};
